import { render, staticRenderFns } from "./FullscreenOverlayFrame.vue?vue&type=template&id=32ea42c1"
import script from "./FullscreenOverlayFrame.vue?vue&type=script&lang=js"
export * from "./FullscreenOverlayFrame.vue?vue&type=script&lang=js"
import style0 from "./FullscreenOverlayFrame.vue?vue&type=style&index=0&id=32ea42c1&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports